exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.register .weui-cells {\n  margin-top: 0.3rem;\n}\n.register .weui-cells:after {\n  border: none !important;\n}\n.register .weui-cells:before {\n  border: none !important;\n}\n", ""]);

// exports
